import BaseService from "../../../services/BaseService";
import axios from 'axios';

class UiSettingService extends BaseService {
	
	async getUISettings(req) {
		try{
    		return await axios.get(`${this.url}/domain/settings`);
  		}catch(e){
  			return e.message;
  		}
  	}
};

export default new UiSettingService('health_backend','org_ui_settings');

